import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Modal } from 'react-bootstrap';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CustomInput from '../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import './editar-noticia.scss'
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Select,
  Stack,
  Checkbox,
  Spinner,
  Alert,
  AlertIcon,
  AlertDescription,
  AlertTitle,
  Wrap,
  TagCloseButton,
  Tag,
  WrapItem,
  TagLabel,
  IconButton,
  Image
} from '@chakra-ui/react';
import { FileWithPath } from 'react-dropzone';
import * as api from '../../../../api/noticia';
import { api as axiosApi } from '../../../../api';
import * as apiOutrasPaginas from '../../../../api/outrasPaginas';
import CustomTextArea from '../../../../components/common/Textarea/textArea';
import Swal from 'sweetalert2';
import { listarCategoriasAtivas } from '../../../../api/categoria';
import { obterUsuario } from '../../../../api/usuario';
import { ImageDropzone } from '../../../PublishContent/components/Banner/imageDropzone';
import { FaPlus, FaMinus, FaTimes, FaImage } from 'react-icons/fa';
import { PublicacaoParams } from '../../../../interfaces/publicacao.interface';
import { deletarSecretariaAssociada, listarSecretariasAtivas } from '../../../../api/secretarias';
import QuillEditor from '../../../../components/common/QuillEditor';
import BibliotecaModal from '../../../../pages/EdicaoCidadeInteligente/OutrasPaginas/modeloOutrasPaginas/BibliotecaModal/BibliotecaModal';

interface Imagem {
  id: number;
  imagem: string;
  imagemPreview: string;
  posicaoImagem: string;
  tipo?: 'image' | 'video';
}

interface Secao {
  id: number;
  titulo: string;
  descricao: string;
  aberto: boolean;
  imagem: Imagem[];
}

const EditarNoticia: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    data: { value: typeof today; error: boolean };
    dataFim: { value: ''; error: boolean };
    imagem: { value: string; error: boolean };
    dscResumo: { value: string; error: boolean };
    endereco: { value: string; error: boolean };
    creditoAutorNoticia: { value: string; error: boolean };
    creditoAutorImagem: { value: string; error: boolean };
    descricaoImagem: { value: string; error: boolean };
    altImagem: { value: string; error: boolean };
    texto: { value: string; error: boolean };
    seqCategoria: { value: any; error: boolean };
    paginaId: { value: any[]; error: boolean };
    secretariaId: {value: any[]; error: boolean };

  }>({
    titulo: { value: '', error: false },
    data: { value: today, error: false },
    dataFim: { value: '', error: false },
    imagem: { value: '', error: false },
    dscResumo: { value: '', error: false },
    endereco: { value: '', error: false },
    creditoAutorNoticia: { value: '', error: false },
    creditoAutorImagem: { value: '', error: false },
    descricaoImagem: { value: '', error: false },
    altImagem: { value: '', error: false },
    texto: { value: '', error: false },
    seqCategoria: { value: '', error: false },
    paginaId: { value: [], error: false },
    secretariaId: {value: [], error: false },

  });

  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [paginas, setPaginas] = useState<any[]>([]);
  const [filtroNomPagina, setFiltroNomPagina] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);
  const [temporaryTexto, setTemporaryTexto] = useState<string>('');
  const [isModalTextOpen, setIsModalTextOpen] = useState<boolean>(false);
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);
  const [seqUsuario, setSeqUsuario] = useState<any[]>([]);
  const [removedPages, setRemovedPages] = useState<number[]>([]);
  const [categorias, setCategorias] = useState<any[]>([]);
  const [secretarias, setSecretarias] = useState<any[]>([]);
  const [filtroNomSecretaria, setFiltroNomSecretaria] = useState<string>('');
  const [secretariaSelecionada, setSecretariaSelecionada] = useState<number[]>([]);
  const [secretariasRemovidas, setSecretariasRemovidas] = useState<number[]>([]);
  const [arquivo, setArquivo] = useState<any>();
  const [arquivoSelecionado, setArquivoSelecionado] = useState<File | null>(null);
  const [imagePreview, setImagePreview] = useState<string>("");
  const [nomeCdn, setNomeCdn] = useState<any>(null);
  const [temImagem, setTemImagem] = useState<boolean>(false)
  const [isLoadingButton, setLoadingButton] = useState<boolean>(false);
  const [isDesativoButton, setDesativoButton] = useState<boolean>(false);
  const [isAtivo, setIsAtivo] = useState<number>(1);
  const [getCodSituacaoPubli, setgetCodSituacaoPubli] = useState<number>(1);
  const [getObjPendencia, setgetObjPendencia] = useState<any>();
  const [inputValueTagUsuario, setInputValueTagUsuario] = useState('');
  const [tagUsuario, setTagUsuario] = useState<string>('');
  const [motivosReprovacao, setMotivosReprovacao] = useState('');

  // Estados para Modelo 1
  const [codModeloPaginaAtual, setCodModeloPaginaAtual] = useState<number | null>(null);
  const [selecao, setSelecao] = useState<Secao[]>([
    {
      id: 1,
      titulo: '',
      descricao: '',
      aberto: true,
      imagem: []
    },
  ]);
  const [bibliotecaOpen, setBibliotecaOpen] = useState<boolean>(false);
  const [secaoAtualId, setSecaoAtualId] = useState<number | null>(null);
  const [listaPosicaoImagem, setListaPosicaoImagem] = useState<
    { codPropriedade: number; dscPropriedade: string }[]
  >([]);

  const videoExts = ['.mp4', '.webm', '.ogg'];

  const fetchNoticiaData = async () => {
    setIsLoading(true);
    try {
      const NoticiaData = await api.obterNoticia(Number(id));
      const {
        nomePublicacao,
        datPublicacao,
        datDespublicar,
        dscCreditoImagem,
        dscCreditoNoticia,
        dscDescricaoImagem,
        dscAltImagem,
        seqCategoria,
        conteudoSecretariaDTO,
        conteudoPaginaDTO,
        binPublicacao,
        urlBin,
        dscResumo,
        dscPublicacao,
        pendencia,
        numRegistro,
        codSituacaoPubli,
        dscCitacaoUsuario,
        codModeloPagina,
        jsonModelo
      } = NoticiaData;
      
      const selecionadas = (conteudoSecretariaDTO ?? []).map((i: any) => Number(i.codSecretaria));

      setFormValues({
        titulo: { value: nomePublicacao, error: false },
        data: { value: datPublicacao || today, error: false },
        dataFim: { value: datDespublicar || '', error: false },
        imagem: { value: binPublicacao || '', error: false },
        endereco: { value: urlBin || '', error: false },
        creditoAutorImagem: { value: dscCreditoImagem || '', error: false },
        descricaoImagem: { value: dscDescricaoImagem || '', error: false },
        altImagem: { value: dscAltImagem || '', error: false },
        seqCategoria: { value: seqCategoria || '', error: false },
        paginaId: { value: conteudoPaginaDTO.map((item: any) => item.seqPagina.toString()), error: false },
        secretariaId: { value: selecionadas, error: false },
        dscResumo: { value: dscResumo || '', error: false },
        creditoAutorNoticia: { value: dscCreditoNoticia || '', error: false },
        texto: { value: dscPublicacao || '', error: false }
      });
      
      setSecretariaSelecionada(selecionadas);

      // Carregar modelo se existir
      if (codModeloPagina && jsonModelo) {
        setCodModeloPaginaAtual(codModeloPagina);
        try {
          const parsedModelo = JSON.parse(jsonModelo);
          const secoesMapeadas = parsedModelo.secoes.map((secao: any) => {
            let imagensTratadas: Imagem[] = [];

            if (secao.imagem) {
              const raw = Array.isArray(secao.imagem)
                ? secao.imagem
                : typeof secao.imagem === 'object'
                  ? [secao.imagem]
                  : [{ url: secao.imagem }];

              imagensTratadas = raw.map((img: any) => ({
                id: img.id || Date.now(),
                imagem: img.url || img.imagem,
                imagemPreview: img.url || img.imagem,
                posicaoImagem: img.posicaoImagem || '',
                tipo: img.tipo || 'image',
              }));
            }

            return {
              id: secao.id || Date.now(),
              titulo: secao.titulo,
              descricao: secao.descricao,
              aberto: secao.aberto !== false,
              imagem: imagensTratadas,
            };
          });

          setSelecao(secoesMapeadas);
        } catch (e) {
          console.error('Erro ao parsear modelo:', e);
        }
      }

      if (NoticiaData.numRegistro == 0) {
        setIsAtivo(0)
      }

      if (NoticiaData.codSituacaoPubli) {
        setgetCodSituacaoPubli(NoticiaData.codSituacaoPubli)
      }
      if (NoticiaData.pendencia) {
        setgetObjPendencia(NoticiaData.pendencia)
      }

      if (NoticiaData.imagem) {
        setImagePreview(NoticiaData.imagem);
      }

      if (pendencia && pendencia.dscObs) {
        setMotivosReprovacao(pendencia.dscObs);
      }
      
      const userTagsArray = (dscCitacaoUsuario || '')
        .split(' ')
        .filter((tag: any) => tag.startsWith('@'));
      setTagUsuario(userTagsArray.join(' '));

      if (binPublicacao && binPublicacao.trim() !== "") {
        setTemImagem(true);

        setFormValues((prev) => ({
          ...prev,
          imagem: { value: binPublicacao, error: false }
        }));

        setImagePreview(atualizarPreview(binPublicacao));
        const delimiter = "%2F";
        const index = binPublicacao.lastIndexOf(delimiter);
        const finalFileName =
          index !== -1 ? binPublicacao.substring(index + delimiter.length) : binPublicacao;
        setNomeCdn(finalFileName);
      } else {
        setTemImagem(false);
      }
    } catch (error) {
      console.error("Erro ao buscar dados da notícia:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchPaginas = async (nomPagina?: string) => {
    try {
      if (nomPagina && nomPagina.trim()) {
        // Chamada com filtro para o endpoint da API
        const url = `/paginas/ativas?nomPagina=${encodeURIComponent(nomPagina)}`;
        const response = await axiosApi.get(url);
        setPaginas(response.data);
      } else {
        // Chamada sem filtro usando a função padrão
        const data = await api.paginasAtivas();
        setPaginas(data);
      }
    } catch (error) {
      console.error('Erro ao buscar páginas ativas:', error);
    }
  };

  const fetchSecretarias = async (dscSecretaria?: string) => {
    try {
      if (dscSecretaria && dscSecretaria.trim()) {
        // Chamada com filtro para o endpoint da API
        const url = `/secretarias/ativas?dscSecretaria=${encodeURIComponent(dscSecretaria)}`;
        const response = await axiosApi.get(url);
        setSecretarias(response.data);
      } else {
        // Chamada sem filtro usando a função padrão
        const data = await listarSecretariasAtivas();
        setSecretarias(data);
      }
    } catch (error) {
      console.error('Erro ao buscar secretárias ativas:', error);
    }
  };

  // Funções para Modelo 1
  const getLabel = (codPropriedade: string) => {
    return listaPosicaoImagem.find(opt => opt.codPropriedade.toString() === codPropriedade)?.dscPropriedade || '';
  };

  const abrirBibliotecaDeFotos = (secaoId: number) => {
    setSecaoAtualId(secaoId);
    setBibliotecaOpen(true);
  };

  const handleSelectImageFromBiblioteca = (media: any) => {
    if (secaoAtualId === null) return;

    const url = decodeURIComponent(media.dscUriCdn || media.dscMidia);
    const limpar = url.split('?')[0].toLowerCase();

    const isVideo = videoExts.some(ext => limpar.endsWith(ext));

    const novaImagem: Imagem = {
      id: Date.now(),
      imagem: url,
      imagemPreview: url,
      posicaoImagem: '',
      tipo: isVideo ? 'video' : 'image'
    };

    setSelecao(prev =>
      prev.map(secao =>
        secao.id === secaoAtualId
          ? { ...secao, imagem: [...secao.imagem, novaImagem] }
          : secao
      )
    );

    setBibliotecaOpen(false);
  };

  const handleRemoveImagem = (secaoId: number, imgId: number) => {
    setSelecao(prevSelecao =>
      prevSelecao.map(secao =>
        secao.id === secaoId
          ? { ...secao, imagem: secao.imagem.filter(img => img.id !== imgId) }
          : secao
      )
    );
  };

  const handleSelecaoChange = (id: number, field: string, value: string) => {
    setSelecao(prevSelecao =>
      prevSelecao.map(secao =>
        secao.id === id ? { ...secao, [field]: value } : secao
      )
    );
  };

  const handleAtualizarPosicaoImagem = (secaoId: number, imgId: number, posicaoImagem: string) => {
    setSelecao(prevSelecao =>
      prevSelecao.map(secao =>
        secao.id === secaoId
          ? { ...secao, imagem: secao.imagem.map(img => img.id === imgId ? { ...img, posicaoImagem } : img) }
          : secao
      )
    );
  };

  const handleAddSelecao = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const novaSelecao: Secao = {
      id: Date.now(),
      titulo: '',
      descricao: '',
      aberto: true,
      imagem: []
    };
    setSelecao(prevSelecao => [...prevSelecao, novaSelecao]);
  };

  const handleRemoverSelecao = (id: number) => {
    setSelecao(prevSelecao => prevSelecao.filter(secao => secao.id !== id));
  };

  const toggleSelecao = (id: number) => {
    setSelecao(prevSelecao =>
      prevSelecao.map(secao =>
        secao.id === id ? { ...secao, aberto: !secao.aberto } : secao
      )
    );
  };

  useEffect(() => {
    const storedUsuario = localStorage.getItem('dadosUsuario');
    if (storedUsuario) {
      try {
        const usuario = JSON.parse(storedUsuario);
        setSeqUsuario(usuario.seqUsuario);
        
        const fetchObterUsuario = async () => {
          try {
           const [data, ativas] = await Promise.all([
             obterUsuario(Number(usuario.seqUsuario)),
             listarSecretariasAtivas()
           ]);
           setSecretarias(
            data.usuarioSecretariaDTO?.length ? data.usuarioSecretariaDTO : ativas
          );
          } catch (error) {
            console.error("Erro ao obter usuario:", error);
          }
        };
  
        fetchObterUsuario();
  
      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }

    const fetchCategorias = async () => {
      try {
        const data = await listarCategoriasAtivas();
        setCategorias(data);
      } catch (error) {
        console.error('Erro ao buscar categorias ativas:', error);
      }
    };

    const listarPosicoes = async () => {
      try {
        const data = await apiOutrasPaginas.listarPosicaoImagem();
        setListaPosicaoImagem(data);
      } catch (error) {
        console.error('Erro ao listar posições de imagem:', error);
      }
    };

    fetchCategorias();
    listarPosicoes();
    fetchNoticiaData();
    fetchPaginas();
  }, []);

  const handleDeletePages = async () => {
    try {
      for (const seqPagina of removedPages) {
        await api.deletarRelacionamentoPagina(Number(id), seqPagina);
      }

      setRemovedPages([]);
    } catch (error) {
      console.error('Erro ao remover páginas:', error);
    }
  };

  const handleDeleteSecretarias = async () => {
    try {
      for (const codSecretaria of secretariasRemovidas) {
        await deletarSecretariaAssociada(codSecretaria, Number(id));
      }

      setSecretariasRemovidas([]);
    } catch (error) {
      console.error('Erro ao remover páginas:', error);
    }
  };

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  const handleAddTagUsuario = () => {
    if (inputValueTagUsuario.trim()) {
      setTagUsuario((prevTagUsuario) =>
        prevTagUsuario ? `${prevTagUsuario} ${inputValueTagUsuario.trim()}` : inputValueTagUsuario.trim()
      );
      setInputValueTagUsuario('');
    }
  };

  const handleRemoveTagUsuario = (tagToRemove: string) => {
    setTagUsuario((prevTagUsuario) => {
      const updatedTags = prevTagUsuario
        .split(' ')
        .filter((tag) => tag !== tagToRemove)
        .join(' ');
      return updatedTags.trim();
    });
  };

  const handleInputChangeTagUsuario = (e: any) => {
    const value = e.target.value;

    const valueWithoutSpaces = value.replace(/\s/g, '');
    if (valueWithoutSpaces && !valueWithoutSpaces.startsWith('@')) {
      setInputValueTagUsuario(`@${valueWithoutSpaces}`);
    } else {
      setInputValueTagUsuario(valueWithoutSpaces);
    }
  };

  const handleCheckboxSecretaria = (codSecretaria: number, checked: boolean) => {
    setSecretariaSelecionada(prev => {
      const next = checked
        ? Array.from(new Set([...prev, codSecretaria]))
        : prev.filter(id => id !== codSecretaria);
      return next;
    });

    setSecretariasRemovidas(prev =>
      checked
        ? prev.filter(id => id !== codSecretaria)
        : Array.from(new Set([...prev, codSecretaria]))
    );

    setFormValues((prev: any) => {
      const current: number[] = Array.isArray(prev?.secretariaId?.value) ? prev.secretariaId.value : [];
      const next = checked
        ? Array.from(new Set([...current, codSecretaria]))
        : current.filter(id => id !== codSecretaria);

      return {
        ...prev,
        secretariaId: { ...prev.secretariaId, value: next, error: prev?.secretariaId?.error ?? false },
      };
    });
  };

  const handleCheckboxChange = (seqPagina: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      setRemovedPages(prev => prev.filter(id => id !== seqPagina));
    } else {
      setRemovedPages(prev => [...prev, seqPagina]);
    }

    setFormValues((prevValues: any) => {
      const updatedPaginaIdValue = isChecked
        ? [...prevValues.paginaId.value, seqPagina.toString()]
        : prevValues.paginaId.value.filter((id: string) => id !== seqPagina.toString());

      return {
        ...prevValues,
        paginaId: { value: updatedPaginaIdValue },
      };
    });
  };

  const handleSaveText = () => {
    handleFieldChange('texto', temporaryTexto);
    setIsModalTextOpen(false);
  };

  const handleOpenModal = () => {
    setTemporaryTexto(formValues.texto.value);
    setIsModalTextOpen(true);
  };

  useEffect(() => {
    const isAutorValid = formValues.creditoAutorNoticia.value.trim() !== '';
    setIsSaveButtonDisabled(!isAutorValid || !temporaryTexto);
  }, [formValues.creditoAutorNoticia.value, temporaryTexto]);

  const atualizarPreview = (url: string): string => {
    if (url.startsWith("data:")) {
      return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}t=${new Date().getTime()}`;
  };

  const handleImageSelected = async (selecionado: FileWithPath | null) => {
    if (selecionado) {
      const isImagem = selecionado.type.startsWith("image/");
      const isVideo = selecionado.type.startsWith("video/");
      const isAudio = selecionado.type.startsWith("audio/");

      setArquivo(selecionado);

      if (isImagem || isVideo || isAudio) {
        setArquivoSelecionado(selecionado);
        setArquivo(selecionado);
      } else {
        console.error("Tipo de arquivo não suportado.");
      }

      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === "string") {
          const novaUrl = atualizarPreview(reader.result);
          setImagePreview(novaUrl);
          setFormValues((prev) => ({
            ...prev,
            imagem: { value: novaUrl, error: false },
          }));
        }
      };
      reader.readAsDataURL(selecionado);
    } else {
      setArquivo(null);
      setArquivoSelecionado(null);
      setImagePreview("");
      console.warn("Nenhum arquivo selecionado.");
    }
  };

  const isFormValid = () => {
    const { titulo, data, seqCategoria, paginaId } = formValues;

    const isValid = (
      titulo.value &&
      data.value &&
      seqCategoria.value &&
      (paginaId.value.length > 0)
    );
    return isValid;
  };
  
  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoadingButton(true);

    await handleDeletePages();
    await handleDeleteSecretarias();

    const { endereco, texto, creditoAutorImagem, creditoAutorNoticia, dataFim, seqCategoria, paginaId, secretariaId, data, imagem, descricaoImagem, altImagem } = formValues;

    // Validação para Modelo 1
    if (codModeloPaginaAtual === 1) {
      let secoesValidas = true;
      for (const secao of selecao) {
        if (!secao.titulo.trim() || !secao.descricao.trim()) {
          secoesValidas = false;
          break;
        }
      }
      if (!secoesValidas) {
        setErrorMessage('Todas as seções devem ter título e descrição preenchidos.');
        setLoadingButton(false);
        setIsErrorModalOpen(true);
        return;
      }
    }

    if (codModeloPaginaAtual !== 1 && !endereco.value && !texto.value) {
      setErrorMessage('É necessário informar o "Endereço de internet para a notícia" ou "Texto da notícia" para editar a notícia.');
      setLoadingButton(false);
      setIsErrorModalOpen(true);
      return;
    }

    if(getCodSituacaoPubli == 6) {
      getObjPendencia['codPendencia'] = 1;
    }

    let codSituacao = 1;

    if (data.value) {
      const dataDaPublicacao = data.value;
      const diaDeHoje = new Date().toISOString().split("T")[0];

      if (getObjPendencia) {
        codSituacao = 5;
      } else if (dataDaPublicacao > diaDeHoje) {
        codSituacao = 1;
      } else if (dataDaPublicacao === diaDeHoje) {
        codSituacao = 2;
      }  
    } else {
      codSituacao = 2;
    }

    // Preparar modelo se houver
    let jsonModelo: string | null = null;
    let binPublicacaoFinal = imagem.value || '';

    if (codModeloPaginaAtual === 1 && selecao.length > 0) {
      const primeiraSecao = selecao[0];
      
      // Se houver imagem na primeira seção, usar a primeira imagem
      if (primeiraSecao.imagem.length > 0) {
        const primeiraImagem = primeiraSecao.imagem[0];
        // Para mídias já no CDN, não fazer upload
        if (primeiraImagem.imagem.startsWith('http')) {
          binPublicacaoFinal = primeiraImagem.imagem;
        }
      }

      // Criar jsonModelo com as seções
      const jsonModeloData = {
        codModeloPagina: 1,
        tituloGeral: formValues.titulo.value,
        secoes: selecao.map(secao => ({
          id: secao.id,
          titulo: secao.titulo,
          descricao: secao.descricao,
          aberto: secao.aberto,
          imagem: secao.imagem.map(img => ({
            id: img.id,
            url: img.imagem,
            posicaoImagem: img.posicaoImagem,
            tipo: img.tipo,
          }))
        }))
      };

      jsonModelo = JSON.stringify(jsonModeloData);
    }

    const params: any = {
      seq_conteudo: Number(id),
      codTipoPublicacao: 1,
      codSituacaoPubli: codSituacao,
      numRegistro: isAtivo,
      nomePublicacao: formValues.titulo.value || null,
      datPublicacao: formValues.data.value ? formValues.data.value : null,
      datDespublicar: dataFim.value ? formValues.dataFim.value : null,
      seqUsuario: seqUsuario,
      binPublicacao: binPublicacaoFinal || '',
      dscResumo: formValues.dscResumo.value || null,
      urlBin: endereco.value || null,
      dscPublicacao: codModeloPaginaAtual === 1 ? (selecao.length > 0 ? selecao[0].descricao : null) : texto.value || null,
      dscCreditoImagem: creditoAutorImagem.value || null,
      dscCreditoNoticia: creditoAutorNoticia.value || null,
      dscDescricaoImagem: descricaoImagem.value || null,
      dscAltImagem: altImagem.value || null,
      seqCategoria: Number(seqCategoria.value) || null,
      dscCitacaoUsuario: tagUsuario,
      conteudoPaginaDTO: paginaId.value.map((id: any) => {
        return {
          seqPagina: Number(id),
          numOrdem: 0,
          datFim: dataFim.value ? formValues.dataFim.value : null,
        };
      }),
      dscTags: null,
      pendencia: getObjPendencia || null,
      numAprovacao: 0,
      numAprovado: 0,
      datInicioEvento: null,
      datFimEvento: null,
      contasRedeSocial: null,
      dscHoraInicioEvento: null,
      dscHoraFimEvento: null,
      dscEnderecoEvento: null,
      conteudoSecretariaDTO: secretariaId.value.map((id: any) => ({
        codSecretaria: Number(id),
      })),
      ...(codModeloPaginaAtual === 1 && { codModeloPagina: 1, jsonModelo: jsonModelo }),
    };

    try {
      if (arquivoSelecionado && temImagem) {
        const formData = new FormData();
        const nomePasta = 'publicacoes';
        const nomeArquivo = nomeCdn || 'noticia';

        formData.append('file', arquivoSelecionado);
        formData.append('fileName', nomeArquivo);
        formData.append('folderName', nomePasta);

        const cdnData = await api.editarNoticiaNoCdn(formData);
        let cdnUrl = "";

        if (typeof cdnData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnData.match(regex);
          if (match && match[0]) {
            cdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnData && cdnData.url) {
          cdnUrl = cdnData.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }

        params.binPublicacao = cdnUrl;
      }

      if (arquivoSelecionado && !temImagem) {
        const formData = new FormData();

        const fileExtension = arquivoSelecionado.name.split('.').pop();
        let fileNameToSend = 'noticia';

        if (
          fileExtension &&
          !fileNameToSend.toLowerCase().endsWith(`.${fileExtension.toLowerCase()}`)
        ) {
          fileNameToSend = `${fileNameToSend}.${fileExtension}`;
        }

        const nomePasta = 'publicacoes';
        const nomeArquivo = nomeCdn || 'noticia';

        formData.append('file', arquivoSelecionado);
        formData.append('fileName', nomeArquivo);
        formData.append('folderName', nomePasta);

        const cdnData = await api.inserirNoticiaNoCdn(formData);
        let cdnUrl = "";

        if (typeof cdnData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnData.match(regex);
          if (match && match[0]) {
            cdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnData && cdnData.url) {
          cdnUrl = cdnData.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }

        params.binPublicacao = cdnUrl;
      }

      // Debug: Log do payload sendo enviado
      console.log('Payload enviado para edição:', JSON.stringify(params, null, 2));
      
      await api.editarPublicacao(id, params);
      setLoadingButton(false);

      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Notícia editada com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate(-1)
      });
    } catch (error) {
      setLoadingButton(false);
      console.error('Erro ao editar notícia:', error);
      
      // Extrair mensagem de erro real
      let errorMessage = 'Erro ao editar notícia. Tente novamente mais tarde.';
      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (typeof error === 'object' && error !== null) {
        if ('response' in error && typeof (error as any).response === 'object') {
          const response = (error as any).response;
          if (response?.data?.message) {
            errorMessage = response.data.message;
          } else if (response?.data?.error) {
            errorMessage = response.data.error;
          } else if (response?.statusText) {
            errorMessage = response.statusText;
          }
        } else if ('message' in error) {
          errorMessage = (error as any).message;
        }
      }
      
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: errorMessage,
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/publicacao/noticia');
      });
    }
  };

  const inativarPublicacao = async () => {
    if(getCodSituacaoPubli == 6) {
      getObjPendencia['codPendencia'] = 3;
    }

    Swal.fire({
      title: 'Tem certeza?',
      text: "Certeza que deseja inativar imediatamente a Publicação?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1789FC',
      cancelButtonColor: '#EDF2F7',
      confirmButtonText: 'Sim, inativar',
      cancelButtonText: 'Cancelar'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const params = {
          pendencia: getObjPendencia || null,
          seqUsuario: seqUsuario,
          numRegistro: 0,
          codSituacaoPubli: 3
        };

        try {
          setDesativoButton(true);
          await api.editarPublicacao(id, params);
          setDesativoButton(false);
          Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            text: 'Notícia inativada com sucesso.',
            confirmButtonColor: '#1789FC',
            confirmButtonText: 'OK',
          }).then(() => {
            navigate(-1)     
          });
        } catch (error) {
          setDesativoButton(false);
          console.error('Erro ao inativar notícia:', error);
          Swal.fire({
            icon: 'error',
            title: 'Ocorreu um erro!',
            text: 'Erro ao inativar notícia. Tente novamente mais tarde.',
            confirmButtonColor: '#1789FC',
            confirmButtonText: 'OK',
          }).then(() => {
            navigate(-1)
          });
        }
      }
    });
  };

  const mostrarMotivoReprovacao = () => {
    const texto = motivosReprovacao || 'Motivos não informados.';
    const isTextoLongo = texto.length > 150;
  
    Swal.fire({
      title: 'Motivos da Reprovação',
      width: isTextoLongo ? '50%' : undefined,
      html: `<div style="max-height: 250px; overflow-y: auto;">
              <p>${texto}</p>
            </div>`,
      icon: 'warning',
      confirmButtonColor: '#1789FC',
      confirmButtonText: 'Entendi'
    });
  };  
  
  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      < SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Editar Notícia
      </Heading>
      {isAtivo == 0 && (
        <Flex justifyContent="end">
          <Alert status="error" mt="35px" borderRadius="md">
            <AlertIcon />
            <Box flex="1">
              <AlertTitle fontSize="lg" mb={1}>Publicação Inativada</AlertTitle>
              <AlertDescription display="block">
                Esta notícia foi permanentemente inativada e não poderá ser reativada.
              </AlertDescription>
            </Box>
          </Alert>
        </Flex>
      )}
      {getCodSituacaoPubli === 6 && (
        <Flex justifyContent="end">
          <Alert status="warning" mt="35px" borderRadius="md">
            <AlertIcon />
            <Box flex="1">
              <AlertTitle fontSize="lg" mb={1}>Publicação Reprovada</AlertTitle>
              <AlertDescription display="block">
                Após revisão, sua publicação não obteve aprovação.{' '}
                <Button variant="link" colorScheme="blue" onClick={mostrarMotivoReprovacao}>
                  Clique aqui para ver os motivos.
                </Button>
              </AlertDescription>
            </Box>
          </Alert>
        </Flex>
      )}
      {isLoading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (

        <Box m="40px 0" w="100%">
          <form onSubmit={handleFormSubmit}>
            <div className="row">
              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.seqCategoria.error}>
                  <FormLabel mb="8px">Categoria da Notícia</FormLabel>
                  <Select
                    placeholder='Selecione uma Categoria'
                    borderColor="gray.300"
                    _hover={{ borderColor: 'blue.500' }}
                    value={formValues.seqCategoria.value}
                    onChange={(e) => handleFieldChange('seqCategoria', e.target.value)}
                  >
                    {categorias.length > 0 ? (
                      categorias.map(categoria => (
                        <option key={categoria.seqCategoria} value={categoria.seqCategoria}>
                          {categoria.dscCategoria}
                        </option>
                      ))
                    ) : (
                      <option disabled>Sem categorias disponíveis</option>
                    )}
                  </Select>
                </FormControl>
              </div>

              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.titulo.error}>
                  <FormLabel mb="8px">Título da Notícia</FormLabel>
                  <CustomInput
                    placeholder="Digite um título"
                    value={formValues.titulo.value}
                    onChange={(e: any) => handleFieldChange('titulo', e.target.value)}
                  />
                </FormControl>
              </div>

              <div className="col-md-6 mb-4">
                <FormControl>
                  <FormLabel mb="8px">Endereço de Internet para a notícia</FormLabel>
                  <CustomInput
                    placeholder="Digite um endereço de internet"
                    value={formValues.endereco.value}
                    onChange={(e) => handleFieldChange('endereco', e.target.value)}
                  />
                </FormControl>
              </div>

              <div className="col-md-3 mb-4">
                <FormControl isRequired>
                  <FormLabel mb="8px">Data para Publicação</FormLabel>
                  <CustomInput
                    id="news-publication-date"
                    type="date"
                    value={formValues.data.value}
                    onChange={(e) => handleFieldChange('data', e.target.value)}
                  />
                </FormControl>
              </div>
              <div className="col-md-3 mb-4">
                <FormControl>
                  <FormLabel mb="8px">Data fim para Publicação</FormLabel>
                  <CustomInput
                    id="news-unpublish-date"
                    type="date"
                    value={formValues.dataFim.value}
                    onChange={(e) => handleFieldChange('dataFim', e.target.value)}
                  />
                </FormControl>
              </div>

            </div>
            {codModeloPaginaAtual !== 1 && (
              <div className="row mb-3">
                <div className="col-md-6 mb-4">
                  <FormControl>
                    <FormLabel mb="8px">Imagem miniatura</FormLabel>
                    <ImageDropzone
                      base64={imagePreview}
                      onImageSelected={handleImageSelected}
                      uploadMessage="Arraste ou selecione uma imagem"
                      height={300}
                    />
                    <input
                      id="image-upload"
                      type="file"
                      style={{ display: 'none' }}
                      accept="image/jpeg, image/png"
                      onChange={(e) => handleImageSelected(e.target.files ? e.target.files[0] : null)}
                    />
                    {imagePreview && (
                      <FormControl isRequired className="mt-3">
                        <FormLabel mb="8px">Crédito/Autor da imagem</FormLabel>
                        <CustomInput
                          placeholder="Digite um crédito ou autor da imagem"
                          value={formValues.creditoAutorImagem.value}
                          onChange={(e) => handleFieldChange('creditoAutorImagem', e.target.value)}
                        />
                      </FormControl>
                    )}
                    {imagePreview && (
                      <>
                        <FormControl className="mt-3">
                          <FormLabel mb="8px">Descrição de imagem</FormLabel>
                          <CustomInput
                            placeholder="Digite o texto alternativo da imagem"
                            value={formValues.altImagem.value}
                            onChange={(e) => handleFieldChange('altImagem', e.target.value)}
                          />
                        </FormControl>
                      </>
                    )}
                  </FormControl>
                </div>
              </div>
            )}
            <div className="row mb-3">
              <div className="col-md-6 mb-4">
                <FormControl mt={'24px'}>
                  <FormLabel mb="8px">Tags</FormLabel>
                  <div style={{ display: 'flex' }}>
                    <CustomInput
                      value={inputValueTagUsuario}
                      onChange={handleInputChangeTagUsuario}
                      placeholder="Digite uma tag"
                      maxLength={100}
                    />
                    <Button onClick={handleAddTagUsuario} ml="2">
                      <FaPlus />
                    </Button>
                  </div>
                </FormControl>
                <div className="rolagem-hashtag">
                  <Wrap spacing="2px">
                    {tagUsuario?.trim() &&
                      tagUsuario.split(' ').map((tag, index) => (
                        <WrapItem key={index}>
                          <Tag variant="solid" colorScheme="blue" maxW="180px" isTruncated>
                            <TagLabel>{tag}</TagLabel>
                            <TagCloseButton onClick={() => handleRemoveTagUsuario(tag)} />
                          </Tag>
                        </WrapItem>
                      ))}
                  </Wrap>
                </div>
                <FormControl mt={'24px'}>
                  <Flex justify="space-between" align="center" mb="8px">
                    <FormLabel mb="8px">
                      Escolha em quais páginas a notícia deve aparecer <span style={{ color: 'red' }}>*</span>
                    </FormLabel>
                  </Flex>
                  <CustomInput
                    placeholder="Filtrar páginas por nome"
                    value={filtroNomPagina}
                    onChange={(e) => {
                      const valor = e.target.value;
                      setFiltroNomPagina(valor);
                      if (valor.trim()) {
                        fetchPaginas(valor);
                      } else {
                        fetchPaginas();
                      }
                    }}
                    mb="12px"
                  />
                  <Box
                    border="1px solid"
                    borderColor="gray.300"
                    borderRadius="md"
                    p={3}
                  >
                    <Box overflow="hidden">
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <colgroup>
                          <col style={{ width: '60px' }} />
                          <col />
                        </colgroup>
                        <thead>
                          <tr>
                            <th style={{ textAlign: 'center', padding: '8px', borderBottom: '1px solid #ddd' }}></th>
                            <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd', color: 'gray' }}>Página</th>
                          </tr>
                        </thead>
                      </table>
                    </Box>

                    <Box
                      className="sidebar-checkbox-pagina"
                      overflowX="auto"
                      overflowY={paginas.length > 5 ? 'auto' : 'visible'}
                      maxH={paginas.length > 5 ? '240px' : 'unset'}
                    >
                      {paginas.length > 0 ? (
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                          <tbody>
                            {paginas.map((pagina: any) => (
                              <tr key={pagina.seqPagina} style={{ borderBottom: '1px solid #eee' }}>
                                <td style={{ textAlign: 'center', padding: '12px', width: '60px' }}>
                                  <Checkbox
                                    className="checkPaginasNoticia"
                                    isChecked={formValues.paginaId.value.includes(pagina.seqPagina.toString())}
                                    onChange={(e) => handleCheckboxChange(pagina.seqPagina, e)}
                                  />
                                </td>
                                <td style={{ textAlign: 'left', padding: '12px' }}>
                                  {pagina.nomPagina}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        <Box p={3} textAlign="center" color="gray.500">
                          Não há páginas disponíveis.
                        </Box>
                      )}
                    </Box>
                  </Box>
                </FormControl>
              </div>
              <div className="col-md-6 mb-4">
                <FormControl>
                  <FormLabel mb="8px">Resumo da Notícia</FormLabel>
                  <CustomTextArea
                    placeholder="Digite um resumo"
                    value={formValues.dscResumo.value}
                    onChange={(e) => handleFieldChange('dscResumo', e.target.value)}
                    height={'90px'}
                  />
                </FormControl>

                <FormControl className='mb-4 mt-4'>
              {secretarias.length > 0 && (
                <>
                  <Flex justify="space-between" align="center">
                    <FormLabel mb="8px">
                      Associe o usuário a uma secretaria (opcional)
                    </FormLabel>
                  </Flex>

                  <CustomInput
                    placeholder="Filtrar secretarias por nome"
                    value={filtroNomSecretaria}
                    onChange={(e) => {
                      const valor = e.target.value;
                      setFiltroNomSecretaria(valor);
                      if (valor.trim()) {
                        fetchSecretarias(valor);
                      } else {
                        fetchSecretarias();
                      }
                    }}
                    mb="12px"
                  />

                  <Box
                    border="1px solid"
                    borderColor="gray.300"
                    borderRadius="md"
                    p={3}
                  >
                    <Box overflow="hidden">
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <colgroup>
                          <col style={{ width: '60px' }} />
                          <col style={{ width: '120px' }} />
                          <col />
                        </colgroup>
                        <thead>
                          <tr>
                            <th style={{ textAlign:'center', padding:'8px', borderBottom:'1px solid #ddd' }}></th>
                            <th style={{ textAlign:'left',   padding:'8px', borderBottom:'1px solid #ddd', color:'gray' }}>Código</th>
                            <th style={{ textAlign:'left',   padding:'8px', borderBottom:'1px solid #ddd', color:'gray' }}>Secretaria</th>
                          </tr>
                        </thead>
                      </table>
                    </Box>

                    <Box 
                      className="sidebar-checkbox-pagina"
                      overflowX="auto"
                      overflowY={secretarias.length > 5 ? 'auto' : 'visible'}
                      maxH={secretarias.length > 5 ? '240px' : 'unset'}
                    >
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <colgroup>
                          <col style={{ width: '60px' }} />
                          <col style={{ width: '120px' }} />
                          <col />
                        </colgroup>
                        <tbody>
                        {secretarias.map((secretaria: any) => {
                          const cod = Number(secretaria.codSecretaria);
                          const nome = secretaria.secretariasDTO?.dscSecretaria ?? secretaria.dscSecretaria ?? '—';

                          return (
                            <tr key={cod}>
                              <td style={{ textAlign: "center", padding: "8px", borderBottom: "1px solid #ddd" }}>
                                <Checkbox
                                  className="checkCategorias"
                                  isChecked={secretariaSelecionada.includes(cod)}
                                  onChange={(e) => handleCheckboxSecretaria(cod, e.target.checked)}
                                />
                              </td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{cod}</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{nome}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                      </table>
                    </Box>
                  </Box>
                </>
              )}
            </FormControl>

                {codModeloPaginaAtual !== 1 && (
                  <Button
                    onClick={handleOpenModal}
                    variant="outline"
                    colorScheme="blue"
                    size="lg"
                    fontSize="md"
                    borderRadius="md"
                    _hover={{ bg: "blue.500", color: "white" }}
                    mt={3}
                  >
                    Texto da Notícia
                  </Button>
                )}
              </div>
            </div>

            {codModeloPaginaAtual === 1 && (
              <div className="row mb-3">
                <div className="col-md-12 mb-4">
                  <Box mb="20px">
                    <Heading size="md" mb="15px">Seções do Modelo</Heading>
                    {selecao.map((secao, index) => {
                      return (
                        <Box
                          key={secao.id}
                          borderWidth="1px"
                          borderRadius="md"
                          p="20px"
                          mb="10px"
                          borderColor={'gray.200'}
                        >
                          <Flex justifyContent="space-between" alignItems="center" mb="10px">
                            <Heading as="h5" size="sm">
                              {secao.titulo || `Seção ${index + 1}`}
                            </Heading>
                            <Flex>
                              <Button variant="ghost" size="xs" onClick={() => toggleSelecao(secao.id)} mr="2">
                                {secao.aberto ? <FaMinus /> : <FaPlus />}
                              </Button>
                              <Button variant="ghost" size="xs" colorScheme="red" onClick={() => handleRemoverSelecao(secao.id)}>
                                <FaTimes />
                              </Button>
                            </Flex>
                          </Flex>
                          {secao.aberto && (
                            <Box>
                              <FormControl mb="10px" isRequired>
                                <FormLabel>Título da Seção</FormLabel>
                                <CustomInput
                                  value={secao.titulo}
                                  onChange={(e) => handleSelecaoChange(secao.id, 'titulo', e.target.value)}
                                  placeholder="Digite o título da seção"
                                />
                              </FormControl>

                              <FormControl mb="10px">
                                <FormLabel>Mídia da Seção</FormLabel>
                                <Flex wrap="wrap" gap="20px">
                                  {secao.imagem.map(img => {
                                    const isVideo = img.tipo === 'video';

                                    return (
                                      <Box
                                        key={img.id}
                                        borderWidth="1px"
                                        borderRadius="md"
                                        p="10px"
                                        bg="#FFF"
                                        boxShadow="md"
                                        position="relative"
                                      >
                                        <Box
                                          w="150px"
                                          h="100px"
                                          bg="#f0f0f0"
                                          borderRadius="4px"
                                          overflow="hidden"
                                          mx="auto"
                                        >
                                          {isVideo ? (
                                            <video
                                              src={img.imagemPreview}
                                              controls
                                              muted
                                              playsInline
                                              style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'contain',
                                                display: 'block'
                                              }}
                                              onClick={e => e.stopPropagation()}
                                            />
                                          ) : (
                                            <Image
                                              src={img.imagemPreview}
                                              alt="Preview da mídia"
                                              w="100%"
                                              h="100%"
                                              objectFit="contain"
                                              display="block"
                                              onClick={e => e.stopPropagation()}
                                            />
                                          )}
                                        </Box>

                                        <IconButton
                                          icon={<FaTimes />}
                                          size="xs"
                                          colorScheme="red"
                                          position="absolute"
                                          top="2"
                                          right="2"
                                          borderRadius="full"
                                          aria-label="Remover mídia"
                                          onClick={e => {
                                            e.stopPropagation();
                                            handleRemoveImagem(secao.id, img.id);
                                          }}
                                        />

                                        <Select
                                          mt="10px"
                                          id={`select-posicaoImagem-${secao.id}-${img.id}`}
                                          value={img.posicaoImagem}
                                          onChange={e => handleAtualizarPosicaoImagem(secao.id, img.id, e.target.value)}
                                        >
                                          <option value="" disabled>Posição</option>
                                          {listaPosicaoImagem.map(option => (
                                            <option
                                              key={option.codPropriedade}
                                              value={option.codPropriedade}
                                            >
                                              {option.dscPropriedade}
                                            </option>
                                          ))}
                                        </Select>
                                      </Box>
                                    );
                                  })}

                                  <Button variant="outline" onClick={() => abrirBibliotecaDeFotos(secao.id)}>
                                    <FaImage color="gray" size="15px" />
                                    <Box pl="6px" mt="4px" fontSize="sm">Adicionar Mídia</Box>
                                  </Button>
                                </Flex>
                              </FormControl>

                              <FormControl mb="10px" isRequired>
                                <FormLabel>Descrição da Seção</FormLabel>
                                <QuillEditor
                                  value={secao.descricao || ''}
                                  placeholder="Digite a descrição da seção"
                                  onChange={(content: string) =>
                                    handleSelecaoChange(secao.id, 'descricao', content)
                                  }
                                />
                              </FormControl>
                            </Box>
                          )}
                        </Box>
                      );
                    })}
                    <Button onClick={handleAddSelecao} _hover={{ opacity: 0.8 }} leftIcon={<FaPlus />} bgColor="#1665D8" color="#FFF">
                      Adicionar Seção
                    </Button>
                  </Box>
                </div>
              </div>
            )}

            <div className="row mb-3">
              <div className="col-md-6 mb-4">
              </div></div>

            <Flex hidden={isAtivo == 0} mt="35px" justifyContent="end">
            <Button
              m="6px"
              onClick={() =>
                navigate(-1)
              }
            >
                Desistir
              </Button>
              <Button
                type="submit"
                m="6px"
                color="#FFF"
                bgColor="#1665D8"
                _hover={{ opacity: 0.8 }}
                isDisabled={!isFormValid()}
                isLoading={isLoadingButton}
                loadingText="Editando Notícia..."
              >
              {getCodSituacaoPubli == 6
                ? 'Reenviar para Aprovação'
                : 'Editar Notícia'}              
              </Button>
              <Button
                onClick={() => inativarPublicacao()}
                m="6px"
                color="white"
                bgColor="red.500"
                _hover={{ bg: "red.600" }}
                isLoading={isDesativoButton}
                loadingText="Desativando Publicação..."
              >
                Inativar Publicação Imediatamente
              </Button>
            </Flex>
            {isAtivo == 0 && (
              <Flex mt="35px" justifyContent="end">
                <Button
                  color="#FFF"
                  bgColor="#1665D8"
                  m="6px"
                  onClick={() => navigate(-1)}
                >
                  Voltar
                </Button>
              </Flex>
            )}
          </form>
        </Box>
      )}

      {codModeloPaginaAtual === 1 && (
        <BibliotecaModal
          isOpen={bibliotecaOpen}
          onClose={() => setBibliotecaOpen(false)}
          onSelectImage={handleSelectImageFromBiblioteca}
        />
      )}

      <Modal show={isErrorModalOpen} onHide={() => setIsErrorModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Atenção!</Modal.Title>
        </Modal.Header>
        <Modal.Body>{errorMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setIsErrorModalOpen(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={isModalTextOpen} onHide={() => setIsModalTextOpen(false)} size="xl" enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title>Digite o texto da notícia</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormControl>
            <CKEditor
              editor={ClassicEditor}
              data={temporaryTexto}
              config={{
                language: 'pt-br',
                toolbar: [
                  'undo', 'redo', '|',
                  'heading', 'bold', 'italic', 'underline', 'strikethrough', '|',
                  'link', '|',
                  'blockQuote', 'insertTable', '|',
                  'horizontalLine',
                ],
                heading: {
                  options: [
                    {
                      model: 'paragraph',
                      title: 'Texto normal',
                      class: 'ck-heading_paragraph'
                    },
                    {
                      model: 'heading1',
                      view: 'h1',
                      title: 'Cabeçalho 1',
                      class: 'ck-heading_heading1'
                    },
                    {
                      model: 'heading2',
                      view: 'h2',
                      title: 'Cabeçalho 2',
                      class: 'ck-heading_heading2'
                    },
                    {
                      model: 'heading3',
                      view: 'h3',
                      title: 'Cabeçalho 3',
                      class: 'ck-heading_heading3'
                    },
                  ]
                },
              }}
              onChange={(event, editor) => {
                const data = editor.getData();
                setTemporaryTexto(data);
              }}
            />
          </FormControl>
          {temporaryTexto && (
            <FormControl isRequired className="mt-3 mb-4">
              <FormLabel>Crédito/Autor da notícia</FormLabel>
              <CustomInput
                placeholder="Digite um crédito ou autor da notícia"
                value={formValues.creditoAutorNoticia.value}
                onChange={(e) => handleFieldChange('creditoAutorNoticia', e.target.value)}
                maxLength={100}
              />
            </FormControl>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setIsModalTextOpen(false)}>
            Desistir
          </Button>
          <Button
            type="submit"
            m="6px"
            color="#FFF"
            bgColor="#1665D8"
            _hover={{ opacity: 0.8 }}
            onClick={handleSaveText}
            disabled={isSaveButtonDisabled}
            isLoading={isLoadingButton}
            loadingText="Salvando..."
          >
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>
    </Flex>
  );
};

export default EditarNoticia;
